(function () {
  'use strict';

  function visible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && !element.hidden;
  }

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function setup(root) {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var form = root.querySelector('[data-mg-rex-form]');
    var slot = root.querySelector('[data-mg-gpo-slot]');
    var summary = root.querySelector('[data-mg-required-summary]');
    var countLabel = root.querySelector('[data-mg-required-count]');
    var progress = root.querySelector('[data-mg-progress-bar]');
    var configTotal = root.querySelector('[data-mg-config-total]');
    var configMonthly = root.querySelector('[data-mg-config-monthly]');
    var heroMonthly = root.querySelector('[data-mg-monthly]');
    var financeMonthly = root.querySelector('[data-mg-finance-monthly]');
    var productPrice = root.querySelector('[data-mg-product-price]');
    var comparePrice = root.querySelector('[data-mg-compare-price]');
    var savingLabel = root.querySelector('[data-mg-saving]');
    var addProxy = root.querySelector('[data-mg-add-proxy]');
    var basePriceCents = parseInt(root.dataset.basePriceCents || '0', 10) || 0;
    var baseComparePriceCents = parseInt(root.dataset.baseComparePriceCents || '0', 10) || basePriceCents;
    var knownCartCount = null;
    var cartRedirectTimer = null;
    var cartModal = root.querySelector('[data-mg-cart-modal]');
    var toast = root.querySelector('[data-mg-toast]');
    var transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

    function setupBuildRenderStatus() {
      var status = root.querySelector('[data-mg-render-status]');
      var heroImage = root.querySelector('[data-mg-profile-hero]');
      var state = String(root.dataset.mgRenderState || 'none');
      var handle = String(root.dataset.mgProductHandle || '');
      var endpoint = String(root.dataset.mgRenderStatusUrl || '');
      if (!status || !heroImage || !handle || !endpoint || state === 'ready' || state === 'none') return;

      var title = status.querySelector('[data-mg-render-title]');
      var message = status.querySelector('[data-mg-render-message]');
      var checks = 0;
      var stopped = false;
      var timer = null;
      var recoveryStarted = false;

      function requestRecovery(data) {
        if (recoveryStarted || !data || !data.retryToken) return;
        recoveryStarted = true;
        var recoveryEndpoint = endpoint.replace(/\/stato-build(?:\?.*)?$/, '/riprova-render');
        fetch(recoveryEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ handle: handle, retryToken: data.retryToken }),
          cache: 'no-store'
        }).then(function (response) {
          return response.json().catch(function () { return {}; });
        }).then(function (result) {
          schedule(500);
          if (!result || !result.ready) {
            window.setTimeout(function () { recoveryStarted = false; }, result && result.processed ? 15000 : 30000);
          }
        }).catch(function () {
          window.setTimeout(function () { recoveryStarted = false; }, 15000);
        });
      }

      function schedule(delay) {
        if (stopped) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(check, delay);
      }

      function complete(data) {
        if (!data || !data.image || !data.image.url) return;
        stopped = true;
        window.clearTimeout(timer);
        var nextImage = new Image();
        nextImage.onload = function () {
          heroImage.src = data.image.url;
          heroImage.srcset = '';
          heroImage.alt = data.image.alt || heroImage.alt;
          root.dataset.mgRenderState = 'ready';
          setText(title, 'La tua build è pronta');
          setText(message, 'La fotografia completa è stata applicata automaticamente.');
          status.classList.add('is-complete');
          window.setTimeout(function () { status.hidden = true; }, 380);
        };
        nextImage.onerror = function () {
          stopped = false;
          schedule(5000);
        };
        nextImage.src = data.image.url;
      }

      function updateWaiting(data) {
        var nextState = data && data.state || 'pending';
        var stage = data && data.stage || 'generating';
        root.dataset.mgRenderState = stage === 'delayed' ? 'delayed' : nextState;
        if (stage === 'manual') {
          setText(title, 'Stiamo controllando la fotografia');
          setText(message, 'Il controllo automatico ha richiesto una verifica aggiuntiva. La build resta salvata e il case vuoto non verrà pubblicato.');
        } else if (nextState === 'fallback') {
          setText(title, 'Stiamo rifinendo la fotografia');
          setText(message, 'Il primo tentativo non ha superato il controllo qualità. Il recupero automatico è già in coda.');
          requestRecovery(data);
        } else if (stage === 'delayed') {
          setText(title, 'La fotografia richiede qualche minuto in più');
          setText(message, 'La scheda è al sicuro e puoi continuare a usarla. La foto completa comparirà qui automaticamente.');
          requestRecovery(data);
        } else {
          setText(title, 'Stiamo assemblando la tua build');
          setText(message, 'ImageGen sta creando il PC completo con i componenti e il case che hai scelto. Di solito servono 2–3 minuti.');
        }
      }

      async function check() {
        if (stopped || !document.documentElement.contains(root)) return;
        checks += 1;
        try {
          var response = await fetch(endpoint + '?handle=' + encodeURIComponent(handle), {
            headers: { Accept: 'application/json' },
            cache: 'no-store'
          });
          if (response.ok) {
            var data = await response.json();
            if (data && data.state === 'ready') {
              complete(data);
              return;
            }
            updateWaiting(data);
          }
        } catch (error) {
          // La scheda resta utilizzabile; un errore di rete non espone mai il case provvisorio.
        }
        if (checks < 240) schedule(document.hidden ? 15000 : 5000);
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden && !stopped) schedule(250);
      });
      schedule(1200);
    }

    setupBuildRenderStatus();
    var assets = {
      case: root.dataset.assetCase,
      caseWhite: root.dataset.assetCaseWhite || root.dataset.assetCase,
      caseBlack: root.dataset.assetCaseBlack || root.dataset.assetCase,
      cpu: root.dataset.assetCpu || root.dataset.assetStorage,
      gpu: root.dataset.assetGpu || root.dataset.assetStorage,
      board: root.dataset.assetBoard,
      boardB650: root.dataset.assetBoardB650 || root.dataset.assetBoard,
      boardMsiB840: root.dataset.assetBoardMsiB840 || root.dataset.assetBoard,
      boardAsrockB850: root.dataset.assetBoardAsrockB850 || root.dataset.assetBoard,
      boardMsiTomahawk: root.dataset.assetBoardMsiTomahawk || root.dataset.assetBoard,
      boardAsusB850: root.dataset.assetBoardAsusB850 || root.dataset.assetBoard,
      boardGigabyteX870: root.dataset.assetBoardGigabyteX870 || root.dataset.assetBoard,
      memory: root.dataset.assetMemory,
      memory16: root.dataset.assetMemory16 || root.dataset.assetMemory,
      memory32: root.dataset.assetMemory32 || root.dataset.assetMemory,
      cooler: root.dataset.assetCooler,
      coolerWraith: root.dataset.assetCoolerWraith || root.dataset.assetCooler,
      coolerAssassin: root.dataset.assetCoolerAssassin || root.dataset.assetCooler,
      cooler240: root.dataset.assetCooler240 || root.dataset.assetCooler,
      storage: root.dataset.assetStorage,
      storage1: root.dataset.assetStorage1 || root.dataset.assetStorage,
      storage2: root.dataset.assetStorage2 || root.dataset.assetStorage,
      storage4: root.dataset.assetStorage4 || root.dataset.assetStorage
    };
    var descriptions = {
      case: 'Vetri temperati, layout dual chamber',
      cpu: 'Processore, core e frequenza operativa',
      gpu: 'Potenza grafica e memoria video',
      board: 'Socket, chipset e connettività',
      memory: 'Memoria e archiviazione NVMe',
      cooler: 'Raffreddamento CPU e ventole',
      storage: 'Espansione NVMe opzionale'
    };

    function hydrateHardwarePresentation(profile) {
      if (!profile) return;

      var specs = Array.isArray(profile.specs) ? profile.specs : [];
      var specsByKey = {};
      specs.forEach(function (spec) {
        var key = String(spec && spec.key || '').toLowerCase();
        if (key) specsByKey[key] = spec;
      });

      ['cpu', 'gpu', 'board', 'memory', 'cooler', 'storage'].forEach(function (type) {
        var spec = specsByKey[type];
        if (spec && spec.asset) assets[type] = profileAssetUrl(spec.asset, 360);
      });

      var hardware = profile.hardware || {};
      var socket = String(hardware.socket || '').toUpperCase();
      var memoryGeneration = String(hardware.memoryGeneration || '').toUpperCase();
      var chipsets = Array.isArray(hardware.chipset)
        ? hardware.chipset.filter(Boolean).map(function (value) { return String(value).toUpperCase(); })
        : [];

      if (socket || chipsets.length || memoryGeneration) {
        descriptions.board = [
          socket ? ('Socket ' + socket) : '',
          chipsets.length ? ('chipset ' + chipsets.join('/')) : '',
          memoryGeneration || ''
        ].filter(Boolean).join(', ');
      } else if (specsByKey.board && specsByKey.board.label) {
        descriptions.board = specsByKey.board.label;
      }

      if (memoryGeneration) {
        descriptions.memory = memoryGeneration + ' e archiviazione NVMe';
      } else if (specsByKey.memory && specsByKey.memory.label) {
        descriptions.memory = specsByKey.memory.label;
      }

      if (specsByKey.cpu && specsByKey.cpu.label) descriptions.cpu = specsByKey.cpu.label;
      if (specsByKey.gpu && specsByKey.gpu.label) descriptions.gpu = specsByKey.gpu.label;
      if (specsByKey.cooler && specsByKey.cooler.label) descriptions.cooler = specsByKey.cooler.label;
      if (specsByKey.storage && specsByKey.storage.label) descriptions.storage = specsByKey.storage.label;
    }
    var caseImages = {
      'DEEPCOOL CG530 BLACK': root.dataset.assetCase01,
      'DEEPCOOL CG530 WHITE': root.dataset.assetCase02,
      'MINIMAL CASE BLACK': root.dataset.assetCase03,
      'MINIMAL CASE WHITE': root.dataset.assetCase04,
      'DARK CAVE AKU CURVED BLACK': root.dataset.assetCase05,
      'DARK CAVE AKU CURVED WHITE': root.dataset.assetCase06,
      'LIAN LI VECTOR V100 BLACK': root.dataset.assetCase07,
      'LIAN LI VECTOR V100 WHITE': root.dataset.assetCase08,
      'MSI MAG PANO 100R BLACK': root.dataset.assetCase09,
      'MSI MAG PANO 100R WHITE': root.dataset.assetCase10,
      'LIAN LI O11D EVO BLACK': root.dataset.assetCase11,
      'LIAN LI O11D EVO WHITE': root.dataset.assetCase12,
      'CORSAIR 3500X BLACK': root.dataset.assetCase13,
      'CORSAIR 3500X WHITE': root.dataset.assetCase14,
      'ANTEC C3 BLACK': root.dataset.assetCase15,
      'ANTEC C3 WHITE': root.dataset.assetCase16,
      'ANTEC C5 BLACK': root.dataset.assetCase17,
      'ANTEC C5 WHITE': root.dataset.assetCase18,
      'ANTEC C7 BLACK': root.dataset.assetCase19,
      'ANTEC C7 WHITE': root.dataset.assetCase20,
      'THERMALTAKE VIEW 380 PINK': root.dataset.assetCase21,
      'NZXT H6 FLOW BLACK': root.dataset.assetCase22,
      'NZXT H6 FLOW WHITE': root.dataset.assetCase23,
      'NZXT H9 FLOW BLACK': root.dataset.assetCase24,
      'NZXT H9 FLOW WHITE': root.dataset.assetCase25,
      'HYTE Y70 INFINITE TOUCH DISPLAY - BLACK': root.dataset.assetCase26,
      'HYTE Y70 INFINITE TOUCH DISPLAY - WHITE': root.dataset.assetCase27
    };
    var gpoAssetImages = {};
    var gpoLivePrices = {};
    var gpoOptionRecords = {};
    var livePriceRequests = {};
    var currentProductName = 'REX';

    function profileAssetUrl(filename, width) {
      if (!filename) return '';
      if (/^https?:\/\//i.test(filename) || String(filename).indexOf('//') === 0) return filename;
      try {
        var profileUrl = new URL(root.dataset.mgProfileUrl, window.location.href);
        profileUrl.pathname = profileUrl.pathname.replace(/[^/]+$/, filename);
        if (width && /\.(png|jpe?g|webp|avif)$/i.test(profileUrl.pathname)) {
          profileUrl.pathname = profileUrl.pathname.replace(/(\.[^.]+)$/i, '_' + width + 'x$1');
        }
        profileUrl.search = '';
        return profileUrl.href;
      } catch (error) {
        return filename;
      }
    }

    function setLines(element, value) {
      if (!element || value === undefined || value === null) return;
      element.textContent = '';
      String(value).split(/\n/).forEach(function (line, index) {
        if (index) element.appendChild(document.createElement('br'));
        element.appendChild(document.createTextNode(line));
      });
    }

    function fitHeroTitle() {
      var title = root.querySelector('.mg-rex-hero h1[data-mg-profile-name], .mg-rex-hero h1');
      if (!title) return;

      // The approved REX composition reserves an exact 58% title rail on
      // desktop. Keep that rail untouched and scale only the typography when
      // a longer product name would cross into the promotional badge.
      title.style.removeProperty('font-size');
      var computedSize = parseFloat(window.getComputedStyle(title).fontSize) || 166;
      var availableWidth = title.clientWidth;
      var naturalWidth = title.scrollWidth;
      if (!availableWidth || !naturalWidth || naturalWidth <= availableWidth) return;

      var fittedSize = Math.max(54, Math.floor((computedSize * availableWidth / naturalWidth) * 100) / 100);
      title.style.fontSize = fittedSize + 'px';
    }

    function fitHeroSubtitle() {
      var subtitle = root.querySelector('.mg-rex-hero h2[data-mg-profile-headline], .mg-rex-hero h2');
      var badge = root.querySelector('.mg-rex-promo-card');
      if (!subtitle || !badge) return;

      subtitle.style.removeProperty('width');
      subtitle.style.removeProperty('max-width');
      if (window.innerWidth < 900) return;

      var subtitleRect = subtitle.getBoundingClientRect();
      var badgeRect = badge.getBoundingClientRect();
      var gapToBadge = Math.floor(badgeRect.left - subtitleRect.left);
      var availableWidth = gapToBadge - 20;
      if (availableWidth < 180) return;

      var style = window.getComputedStyle(subtitle);
      var canvas = fitHeroSubtitle.canvas || (fitHeroSubtitle.canvas = document.createElement('canvas'));
      var context = canvas.getContext('2d');
      if (!context) return;
      context.font = style.font;
      var naturalWidth = context.measureText(textOf(subtitle)).width;
      // Preserve the approved REX master: its optical ending crosses the
      // measured badge rail by only four pixels without a visible collision.
      // Reflow only meaningful overflows, not font-metric rounding/noise.
      var opticalTolerance = 8;
      if (naturalWidth > gapToBadge + opticalTolerance) {
        subtitle.style.width = availableWidth + 'px';
        subtitle.style.maxWidth = availableWidth + 'px';
      }
    }

    var fitHeroTitleFrame = null;
    function scheduleHeroTitleFit() {
      if (fitHeroTitleFrame) window.cancelAnimationFrame(fitHeroTitleFrame);
      fitHeroTitleFrame = window.requestAnimationFrame(function () {
        fitHeroTitleFrame = null;
        fitHeroTitle();
        fitHeroSubtitle();
      });
    }

    function recommendationSummary(product, kind) {
      var source = String(product.title || '').toUpperCase();
      if (kind === 'monitor') {
        var resolution = (source.match(/(?:4K ULTRA HD|4K|WQHD|QUAD HD|QHD|FULL HD|FHD)/) || [])[0];
        var refresh = (source.match(/\d{2,3}\s*HZ/) || [])[0];
        var response = (source.match(/\d(?:[.,]\d+)?\s*MS/) || [])[0];
        var panel = (source.match(/(?:QD-OLED|OLED|RAPID IPS|FAST IPS|IPS|FAST VA|VA)/) || [])[0];
        return [resolution, refresh, response, panel].filter(Boolean).join(' · ') || 'DISPLAY ABBINATO ALLA POTENZA DELLA BUILD';
      }
      return kind === 'kit' ? 'TASTIERA, MOUSE, CUFFIE E TAPPETINO PRONTI PER GIOCARE' : '';
    }

    function recommendedMonitorHandle(profile) {
      var games = profile && profile.performance && Array.isArray(profile.performance.games)
        ? profile.performance.games
        : [];
      var values = games.map(function (game) { return Number(game.standard); }).filter(Number.isFinite);
      if (!values.length) return '';
      var averageFps = values.reduce(function (total, value) { return total + value; }, 0) / values.length;
      if (averageFps < 155) return 'msi-monitor-gaming-24-5-180hz-1ms-fhd-ips-rapid-hdr-fhd';
      if (averageFps < 240) return 'aoc-q27g4xnd-monitor-gaming-27-wqhd-2560x1440-fast-va-180hz-1ms-gtg-hdr10-adaptive-sync-freesync-premium';
      return 'asus-rog-strix-xg32ucwg-monitor-gaming-31-5-4k-ultra-hd-oled';
    }

    function hydrateRecommendation(handle, kind) {
      if (!handle) return;
      var imageOverrides = {
        'msi-monitor-gaming-24-5-180hz-1ms-fhd-ips-rapid-hdr-fhd': 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-monitor-msi-cutout-v2.avif?v=1788108607',
        'aoc-q27g4xnd-monitor-gaming-27-wqhd-2560x1440-fast-va-180hz-1ms-gtg-hdr10-adaptive-sync-freesync-premium': 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-monitor-aoc-q27-cutout-v2.avif?v=1788108608',
        'kit-gaming-minimal-gamers-4in1-mouse-rgb-tastiera-rgb-tappetino-cuffie': 'https://cdn.shopify.com/s/files/1/0511/1254/2397/files/mg-kit-4in1-cutout-v2.avif?v=1788120335'
      };
      window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Prodotto consigliato non disponibile');
          return response.json();
        })
        .then(function (product) {
          var variant = (product.variants || []).find(function (item) { return item.available; });
          if (!variant) return;
          var url = '/products/' + handle;
          var image = imageOverrides[handle] || product.featured_image || (product.images || [])[0];
          root.querySelectorAll('[data-mg-cross-product="' + kind + '"], [data-mg-modal-product="' + kind + '"]').forEach(function (card) {
            var title = card.querySelector('[data-mg-card-title], h3');
            var copy = card.querySelector('.mg-smart-choice__copy > p, p');
            var picture = card.querySelector('img');
            var price = card.querySelector('form strong, :scope > strong');
            var input = card.querySelector('form input[name="id"]');
            if (title) setText(title, product.title || 'PRODOTTO CONSIGLIATO');
            if (copy) setText(copy, recommendationSummary(product, kind));
            if (picture && image) {
              picture.src = image;
              picture.alt = (product.title || 'Prodotto consigliato') + ' per ' + currentProductName;
            }
            if (price) setText(price, formatEuro(Number(variant.price || 0)));
            if (input) {
              var recommendationVariantId = String(variant.id || '');
              input.value = recommendationVariantId;
              input.setAttribute('value', recommendationVariantId);
              card.dataset.mgRecommendationVariantId = recommendationVariantId;
            }
            card.dataset.mgRecommendationUrl = url;
            if (card.hasAttribute('data-mg-preview-card')) {
              var detailNode = document.createElement('div');
              detailNode.innerHTML = product.description || '';
              card.dataset.mgPreviewTitle = product.title || 'PRODOTTO CONSIGLIATO';
              card.dataset.mgPreviewCopy = recommendationSummary(product, kind);
              card.dataset.mgPreviewDetail = String(detailNode.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 620);
              card.dataset.mgPreviewSpecs = recommendationSummary(product, kind);
              card.dataset.mgPreviewPrice = formatEuro(Number(variant.price || 0));
              card.dataset.mgPreviewVariant = String(variant.id || '');
              card.dataset.mgPreviewUrl = url;
              card.removeAttribute('role');
              card.removeAttribute('tabindex');
              return;
            }
            card.tabIndex = 0;
            card.setAttribute('role', 'link');
            card.setAttribute('aria-label', 'Apri la scheda di ' + (product.title || 'questo prodotto'));
            if (card.dataset.mgRecommendationReady !== 'true') {
              card.dataset.mgRecommendationReady = 'true';
              card.addEventListener('click', function (event) {
                if (event.target.closest('form,button,a')) return;
                window.location.assign(card.dataset.mgRecommendationUrl);
              });
              card.addEventListener('keydown', function (event) {
                if ((event.key === 'Enter' || event.key === ' ') && !event.target.closest('form,button,a')) {
                  event.preventDefault();
                  window.location.assign(card.dataset.mgRecommendationUrl);
                }
              });
            }
          });
        })
        .catch(function () {});
    }

    function applyProductProfile(profile) {
      if (!profile) return;
      var productProfile = profile.product || {};
      var isConfigurator = root.dataset.mgConfigurator === 'true' || productProfile.productClass === 'configurator';
      root.classList.toggle('is-configurator-build', isConfigurator);
      var productName = String(productProfile.name || '').trim();
      if (productName) {
        currentProductName = productName;
        var productReference = productName === 'REX' ? 'il tuo REX' : ('il PC Gaming ' + productName);
        var productPossessive = productName === 'REX' ? 'DEL REX' : ('DI ' + productName);
        root.querySelectorAll('[data-mg-profile-name]').forEach(function (element) { setText(element, productName); });
        root.querySelectorAll('[data-mg-profile-audio-label]').forEach(function (element) {
          setText(element, productProfile.audioLabel || ('ASCOLTA COME È FATTO IL ' + productName));
        });
        root.querySelectorAll('[data-mg-profile-config-title]').forEach(function (element) {
          element.textContent = '';
          var highlight = document.createElement('span');
          highlight.textContent = 'PERSONALIZZA';
          element.appendChild(highlight);
          element.appendChild(document.createTextNode(' IL TUO ' + productName));
        });
        root.querySelectorAll('[data-mg-profile-complete-title]').forEach(function (element) { setText(element, 'HAI COMPLETATO IL TUO ' + productName + '?'); });
        root.querySelectorAll('[data-mg-profile-atc-label]').forEach(function (element) { setText(element, 'AGGIUNGI IL ' + productName + ' AL CARRELLO'); });
        root.querySelectorAll('[data-mg-profile-cross-title]').forEach(function (element) { setText(element, 'COMPLETA IL TUO ' + productName); });
        root.querySelectorAll('[data-mg-profile-machine-title]').forEach(function (element) {
          setText(element, isConfigurator ? (productName + '.') : 'LA MACCHINA.');
        });
        root.querySelectorAll('[data-mg-profile-machine-guide]').forEach(function (element) {
          setText(element, isConfigurator ? ('QUESTA È LA CONFIGURAZIONE COMPLETA DI ' + productName + '.') : ('QUESTA È LA CONFIGURAZIONE BASE ' + productPossessive + '.'));
        });
        root.querySelectorAll('[data-mg-profile-machine-copy]').forEach(function (element) {
          setText(element, isConfigurator ? 'Qui trovi tutti e soltanto i componenti che hai scelto: nessun elemento generico e nessun extra nascosto.' : 'Ogni componente è visibile, leggibile e pronto per essere personalizzato.');
        });
        root.querySelectorAll('[data-mg-profile-order-nav]').forEach(function (element) { setText(element, 'TRACCIA ORDINE ' + productName); });
        root.querySelectorAll('[data-mg-profile-standard-label]').forEach(function (element) { setText(element, productName + ' STANDARD'); });
        root.querySelectorAll('[data-mg-profile-booster-atc]').forEach(function (element) { setLines(element, 'AGGIUNGI IL\nBOOSTER A ' + productName); });
        root.querySelectorAll('[data-mg-profile-tracking-copy]').forEach(function (element) { setText(element, 'Quando ' + productReference + ' lascia il laboratorio ricevi automaticamente il link BRT per seguire la consegna in tempo reale.'); });
        root.querySelectorAll('[data-mg-profile-video-kicker]').forEach(function (element) { setText(element, productName + ' IN AZIONE'); });
        root.querySelectorAll('[data-mg-profile-video-copy]').forEach(function (element) { setText(element, 'Gameplay reale, fluidità e dettaglio: scopri ' + productName + ' prima ancora di accenderlo.'); });
        root.querySelectorAll('[data-mg-profile-cart-added]').forEach(function (element) { setText(element, productName + ' AGGIUNTO CORRETTAMENTE'); });
        root.querySelectorAll('[data-mg-profile-monitor-copy]').forEach(function (element) { setText(element, 'Fluidità e definizione abbinate alle prestazioni di ' + productName + '.'); });
        root.querySelectorAll('[data-mg-profile-booster-copy]').forEach(function (element) { setText(element, 'Ottimizzazione, test e profilo su misura per ' + productReference + '.'); });
        root.querySelectorAll('[data-mg-profile-audio-button]').forEach(function (element) { element.setAttribute('aria-label', 'Riproduci presentazione audio di ' + productName); });
        root.querySelectorAll('[data-mg-profile-monitor-alt]').forEach(function (element) { element.alt = 'Monitor gaming consigliato per ' + productName; });
        root.querySelectorAll('[data-mg-profile-kit-alt]').forEach(function (element) { element.alt = 'Kit gaming consigliato per ' + productName; });
        root.querySelectorAll('iframe[data-mg-profile-video]').forEach(function (element) { element.title = 'PC Gaming ' + productName + ' in azione'; });
      }
      if (productProfile.headline) root.querySelectorAll('[data-mg-profile-headline]').forEach(function (element) { setText(element, productProfile.headline); });
      if (productProfile.heroAsset) {
        var hero = root.querySelector('[data-mg-profile-hero]');
        if (hero) {
          var expectedHeroPath = productProfile.heroAsset.replace(/(\.[^.]+)$/i, '_720x$1');
          if (decodeURIComponent(hero.src).indexOf(expectedHeroPath) === -1) hero.src = profileAssetUrl(productProfile.heroAsset, 720);
          hero.alt = productName ? ('PC Gaming ' + productName) : hero.alt;
        }
      }

      var promotion = profile.promotion || {};
      var promoCard = root.querySelector('[data-mg-copy-code]');
      if (promoCard && promotion.code) {
        promoCard.dataset.code = promotion.code;
        promoCard.setAttribute('aria-label', 'Copia il codice sconto ' + promotion.code);
        setText(root.querySelector('[data-mg-profile-promo-code]'), promotion.code);
      }
      if (promotion.label) setText(root.querySelector('[data-mg-profile-promo-label]'), promotion.label);
      if (promotion.discountLabel) setText(root.querySelector('[data-mg-profile-promo-discount]'), promotion.discountLabel);

      var bundleContents = Array.isArray(profile.bundleContents) ? profile.bundleContents : [];
      var bundleSection = root.querySelector('[data-mg-bundle-included]');
      var bundleItems = root.querySelector('[data-mg-bundle-items]');
      var isBundle = productProfile.productClass === 'bundle' && bundleContents.length > 0;
      root.classList.toggle('is-mg-bundle-product', isBundle);
      if (bundleSection) bundleSection.hidden = !isBundle;
      if (bundleItems) {
        bundleItems.textContent = '';
        bundleContents.forEach(function (item) {
          var article = document.createElement('article');
          article.dataset.bundleKey = item.key || '';
          var image = document.createElement('img');
          image.src = profileAssetUrl(item.asset, 640);
          image.alt = item.label || 'Prodotto incluso nel bundle';
          image.width = 720;
          image.height = 480;
          image.loading = 'lazy';
          image.decoding = 'async';
          var copy = document.createElement('div');
          var badge = document.createElement('span');
          badge.textContent = 'INCLUSO';
          var title = document.createElement('h3');
          title.textContent = item.label || '';
          var detail = document.createElement('p');
          detail.textContent = item.detail || '';
          copy.appendChild(badge);
          copy.appendChild(title);
          copy.appendChild(detail);
          article.appendChild(image);
          article.appendChild(copy);
          bundleItems.appendChild(article);
        });
      }
      if (isBundle) {
        root.querySelectorAll('[data-mg-cross-product="monitor"], [data-mg-cross-product="kit"], [data-mg-modal-extra], .mg-rex-crosssell .is-loop-clone').forEach(function (element) {
          element.hidden = true;
        });
        root.querySelectorAll('[data-mg-profile-cross-title]').forEach(function (element) { setText(element, 'POTENZIA IL TUO ' + (productName || 'BUNDLE')); });
        var modalHeader = cartModal && cartModal.querySelector('header p');
        if (modalHeader) setText(modalHeader, 'Aggiungi il profilo Minimal Booster alla tua postazione completa.');
      } else {
        var crossSellHandles = Array.isArray(profile.crossSellHandles) ? profile.crossSellHandles : [];
        hydrateRecommendation(recommendedMonitorHandle(profile) || crossSellHandles[0], 'monitor');
        hydrateRecommendation(crossSellHandles[1], 'kit');
      }

      var specs = Array.isArray(profile.specs) ? profile.specs : [];
      var machineRail = root.querySelector('.mg-rex-machine__rail');
      if (isConfigurator && machineRail) {
        machineRail.textContent = '';
        specs.forEach(function (spec, index) {
          var card = document.createElement('article');
          card.dataset.mgSpecIndex = String(index);
          card.dataset.mgSpecKey = spec.key || spec.category || '';
          var image = document.createElement('img');
          image.setAttribute('data-mg-spec-image', '');
          image.width = 160;
          image.height = 160;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = spec.alt || spec.label || 'Componente selezionato';
          if (spec.asset) image.src = profileAssetUrl(spec.asset, 360);
          else image.hidden = true;
          image.addEventListener('error', function () { image.hidden = true; });
          var copy = document.createElement('span');
          var label = document.createElement('b');
          label.setAttribute('data-mg-spec-label', '');
          setText(label, spec.label || '');
          var detail = document.createElement('small');
          detail.setAttribute('data-mg-spec-detail', '');
          setLines(detail, spec.detail || '');
          copy.append(label, detail);
          card.append(image, copy);
          machineRail.appendChild(card);
        });
      } else {
        root.querySelectorAll('[data-mg-spec-index]').forEach(function (card) {
          var spec = specs[Number(card.dataset.mgSpecIndex)];
          if (!spec) return;
          setText(card.querySelector('[data-mg-spec-label]'), spec.label || '');
          setLines(card.querySelector('[data-mg-spec-detail]'), spec.detail || '');
          var image = card.querySelector('[data-mg-spec-image]');
          if (image && spec.asset) image.src = profileAssetUrl(spec.asset, 360);
          if (image && spec.alt) image.alt = spec.alt;
        });
      }

      var performance = profile.performance || {};
      var games = Array.isArray(performance.games) ? performance.games : [];
      root.querySelectorAll('[data-mg-game-index]').forEach(function (row) {
        var game = games[Number(row.dataset.mgGameIndex)];
        if (!game) return;
        setText(row.querySelector('[data-mg-game-name]'), game.name || '');
        var standard = row.querySelector('[data-fps-standard]');
        var boosted = row.querySelector('[data-fps-boost]');
        if (standard && Number.isFinite(Number(game.standard))) standard.dataset.base = String(game.standard);
        if (boosted && Number.isFinite(Number(game.booster))) boosted.dataset.base = String(game.booster);
        var image = row.querySelector('[data-mg-game-image]');
        if (image && game.asset) image.src = profileAssetUrl(game.asset, 144);
        if (image && game.name) image.alt = game.name;
        if (game.color) row.style.setProperty('--game', game.color);
      });
      if (performance.defaultResolution) root.dataset.mgDefaultResolution = String(performance.defaultResolution).toLowerCase();

      var storyTitle = root.querySelector('[data-mg-profile-story-title]');
      var storyIntro = root.querySelector('[data-mg-story-intro]');
      var storyPerformance = root.querySelector('[data-mg-story-performance]');
      var storyStrength = root.querySelector('[data-mg-story-strength]');
      var storyBooster = root.querySelector('[data-mg-story-booster]');
      var storyIncluded = root.querySelector('[data-mg-story-included]');
      var storyCustomize = root.querySelector('[data-mg-story-customize]');
      if (storyTitle) setText(storyTitle, 'PC GAMING ' + (productName || 'QUESTA BUILD') + '. POTENZA CHE SI SENTE.');
      var cpuStorySpec = specs.find(function (spec) { return spec.key === 'cpu'; });
      var gpuStorySpec = specs.find(function (spec) { return spec.key === 'gpu'; });
      var memoryStorySpec = specs.find(function (spec) { return spec.key === 'memory' || spec.key === 'ram'; });
      var storageStorySpec = specs.find(function (spec) { return spec.key === 'storage' || spec.key === 'ssd'; });
      if (storyIntro) setText(storyIntro, (productProfile.lead || productProfile.headline || 'Una build progettata per trasformare ogni comando in una risposta immediata.') + (isConfigurator ? ' Ogni scelta è già compresa nel prezzo mostrato e verrà rispettata durante assemblaggio, cablaggio e collaudo.' : ' La configurazione base è completa e ogni componente indicato qui sotto è già compreso nel prezzo mostrato.'));
      if (storyIncluded) {
        storyIncluded.textContent = '';
        [['GPU', gpuStorySpec], ['CPU', cpuStorySpec], ['RAM', memoryStorySpec], ['SSD', storageStorySpec]].forEach(function (entry) {
          if (!entry[1]) return;
          var item = document.createElement('span');
          var label = document.createElement('small');
          var value = document.createElement('b');
          label.textContent = entry[0] + ' INCLUSA';
          value.textContent = entry[1].label || entry[1].detail || 'COMPONENTE BASE';
          item.append(label, value);
          storyIncluded.append(item);
        });
      }
      if (storyPerformance && games.length) {
        var gameProof = games.slice(0, 3).map(function (game) {
          return game.name + ' fino a ' + game.standard + ' FPS';
        }).join(', ');
        setText(storyPerformance, 'È una build gaming pronta a dare soddisfazione nei titoli più giocati: ' + gameProof + ' alla risoluzione consigliata. Fluidità, risposta e margine per giocare forte oggi, con numeri concreti per capire subito quanto può spingere.');
      }
      if (storyStrength && specs.length) {
        setText(storyStrength, [gpuStorySpec && gpuStorySpec.label, cpuStorySpec && cpuStorySpec.label].filter(Boolean).join(' + ') || 'PRESTAZIONI EQUILIBRATE, COMPONENTI REALI, ZERO SORPRESE.');
      }
      if (storyCustomize) setText(storyCustomize, isConfigurator
        ? 'La configurazione è già definita: ritrovi esattamente le scelte confermate nel configuratore, con prezzo bloccato e compatibilità verificata prima dell’assemblaggio.'
        : 'La base indicata è già pronta e completa. Allo STEP 2 puoi personalizzare ' + (productName || 'la build') + ' scegliendo gli upgrade disponibili: il configuratore mantiene compatibilità e variazioni di prezzo sempre leggibili prima dell’acquisto.');
      if (storyBooster) setText(storyBooster, 'Al checkout puoi aggiungere Minimal Booster a ' + (productName || 'questa build') + ': ottimizzazione, stress test e profilo su misura per completare l’esperienza di gioco e ricevere una macchina realmente definita.');

      if (productProfile.youtubeId) {
        var video = root.querySelector('[data-mg-profile-video]');
        if (video) {
          video.src = 'https://www.youtube.com/embed/' + encodeURIComponent(productProfile.youtubeId) + '?autoplay=1&mute=1&controls=1&playsinline=1&rel=0';
          video.title = 'PC Gaming ' + (productName || '') + ' in azione';
        }
      }
      scheduleHeroTitleFit();
      root.dispatchEvent(new CustomEvent('mg:product-profile', { detail: profile }));
    }

    window.addEventListener('resize', scheduleHeroTitleFit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleHeroTitleFit);

    function prepareProfile(profile) {
      if (!profile) return null;
      hydrateHardwarePresentation(profile);
      var fields = profile && profile.gpo && Array.isArray(profile.gpo.fields)
        ? profile.gpo.fields
        : (profile && profile.gpo && Array.isArray(profile.gpo.groups) ? profile.gpo.groups : []);
      fields.forEach(function (field) {
        (field.options || []).forEach(function (option) {
          if (!option.label) return;
          var optionKey = String(option.label).toUpperCase();
          if (option.asset) gpoAssetImages[optionKey] = profileAssetUrl(option.asset, 360);
          if (Number.isFinite(Number(option.price))) gpoLivePrices[optionKey] = Math.round(Number(option.price) * 100);
          gpoOptionRecords[optionKey] = {
            productHandle: option.productHandle || null,
            variantId: option.variantId || null
          };
        });
      });
      return profile;
    }

    function inlineProfile() {
      var node = root.querySelector('[data-mg-inline-profile]');
      if (!node || !node.textContent.trim()) return null;
      try {
        var parsed = JSON.parse(node.textContent);
        if (typeof parsed === 'string') parsed = JSON.parse(parsed);
        return parsed;
      } catch (error) {
        return null;
      }
    }

    var embeddedProfile = inlineProfile();
    var profilePromise = embeddedProfile
      ? Promise.resolve(prepareProfile(embeddedProfile))
      : (root.dataset.mgProfileUrl
        ? window.fetch(root.dataset.mgProfileUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Profilo prodotto non disponibile');
            return response.json();
          })
          .then(prepareProfile)
          .catch(function () { return null; })
        : Promise.resolve(null));
    function groupTypeFromLabel(label) {
      var upper = label.toUpperCase();
      if (upper.indexOf('CASE') > -1) return 'case';
      if (upper.indexOf('PROCESSORE') > -1 || /(^|\s)CPU(\s|$)/.test(upper)) return 'cpu';
      if (upper.indexOf('SCHEDA VIDEO') > -1 || upper.indexOf('GPU') > -1 || upper.indexOf('GRAPHICS') > -1) return 'gpu';
      if (upper.indexOf('MOTHERBOARD') > -1 || upper.indexOf('SCHEDA MADRE') > -1) return 'board';
      if (upper.indexOf('RAM') > -1) return 'memory';
      if (upper.indexOf('DISSIPATORE') > -1 || upper.indexOf('COOLER') > -1) return 'cooler';
      if (upper.indexOf('ARCHIVIAZIONE') > -1 || upper.indexOf('SSD') > -1) return 'storage';
      return 'storage';
    }

    function displayGroupLabel(label, type) {
      if (type === 'board') return 'SCHEDA MADRE';
      return label.replace(/\s*\*\s*$/, '').trim();
    }

    function optionLabel(input) {
      return input.closest('label') || (input.id ? form.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null);
    }

    function optionImage(label, type) {
      if (!label) return assets[type] || assets.storage;
      var name = textOf(label).toUpperCase();
      var exactAsset = Object.keys(gpoAssetImages)
        .sort(function (a, b) { return b.length - a.length; })
        .find(function (key) { return name.indexOf(key) > -1; });
      if (exactAsset && gpoAssetImages[exactAsset]) return gpoAssetImages[exactAsset];
      if (type === 'case') {
        var nativeImage = Array.prototype.slice.call(label.querySelectorAll('img')).find(function (image) {
          return !image.closest('.mg-gpo-option-image');
        });
        if (nativeImage) {
          var nativeSource = nativeImage.currentSrc || nativeImage.getAttribute('src');
          if (nativeSource) return nativeSource;
        }
        var exactCase = Object.keys(caseImages).find(function (key) { return name.indexOf(key) > -1; });
        if (exactCase && caseImages[exactCase]) return caseImages[exactCase];
        if (/WHITE|BIANCO/.test(name)) return assets.caseWhite;
        if (/BLACK|NERO/.test(name)) return assets.caseBlack;
      }
      if (type === 'board') {
        if (/B650\s+GAMING\s+X/.test(name)) return assets.boardB650;
        if (/MSI\s+PRO\s+B840/.test(name)) return assets.boardMsiB840;
        if (/ASROCK\s+B850/.test(name)) return assets.boardAsrockB850;
        if (/MSI\s+MAG\s+B850\s+TOMAHAWK/.test(name)) return assets.boardMsiTomahawk;
        if (/ASUS\s+ROG\s+STRIX\s+B850/.test(name)) return assets.boardAsusB850;
        if (/GIGABYTE\s+X870/.test(name)) return assets.boardGigabyteX870;
      }
      if (type === 'memory') {
        if (/32GB\s+DDR5/.test(name)) return assets.memory32;
        if (/16GB\s+DDR5/.test(name)) return assets.memory16;
      }
      if (type === 'cooler') {
        if (/WRAITH\s+STEALTH/.test(name)) return assets.coolerWraith;
        if (/ASSASSIN\s+X/.test(name)) return assets.coolerAssassin;
        if (/LIQUIDO\s+240|240MM/.test(name)) return assets.cooler240;
      }
      if (type === 'storage') {
        if (/4TB\s+AGGIUNTIVO/.test(name)) return assets.storage4;
        if (/2TB\s+AGGIUNTIVO/.test(name)) return assets.storage2;
        if (/1TB\s+AGGIUNTIVO/.test(name)) return assets.storage1;
      }
      return assets[type] || assets.storage;
    }

    function selectedOptionImage(group, type) {
      var checked = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (!checked) {
        var select = group.querySelector('select');
        if (select && select.value && select.selectedIndex >= 0) {
          var proxy = document.createElement('span');
          proxy.textContent = textOf(select.options[select.selectedIndex]);
          return optionImage(proxy, type);
        }
        // An incomplete native select must preview the component declared by
        // the product profile, not the first purchasable GPO option. These can
        // differ (for example HECTORE declares a Ryzen 7 while its shared set
        // currently lists a Ryzen 5 first).
        return assets[type] || assets.storage;
      }
      var label = optionLabel(checked);
      var decorated = label && label.querySelector('.mg-gpo-option-image img');
      return (decorated && (decorated.dataset.src || decorated.getAttribute('src'))) || optionImage(label, type);
    }

    function groupSelectedText(group) {
      var checked = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      if (checked) {
        var label = optionLabel(checked);
        var clone = label ? label.cloneNode(true) : null;
        if (clone) clone.querySelectorAll('.mg-gpo-option-image, input').forEach(function (node) { node.remove(); });
        var checkedText = clone ? textOf(clone) : (checked.value || 'Selezionato');
        return checkedText.replace(/^\+\s*/, '') || 'Selezionato';
      }
      var select = group.querySelector('select');
      if (select && select.value) {
        var option = select.options[select.selectedIndex];
        return option ? textOf(option) : select.value;
      }
      var dropdownValue = group.querySelector('.dropdown-button__value');
      var value = textOf(dropdownValue);
      if (value && !/seleziona/i.test(value)) return value;
      return '';
    }

    function groupRequired(group) {
      return group.dataset.mgRequired === 'true';
    }

    function groupComplete(group) {
      if (group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')) return true;
      var select = group.querySelector('select');
      if (select) return !!select.value;
      var textInput = group.querySelector('input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])');
      return !!(textInput && textInput.value.trim());
    }

    function parseMoneyCents(value) {
      var text = String(value || '').replace(/[^0-9,.-]/g, '').trim();
      if (!text) return 0;
      var normalized = text.indexOf(',') > -1
        ? text.replace(/\./g, '').replace(',', '.')
        : text;
      var amount = Number.parseFloat(normalized);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    function formatEuro(cents) {
      var amount = cents / 100;
      var decimals = cents % 100 === 0 ? 0 : 2;
      return '€' + new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: 2
      }).format(amount);
    }

    function cleanOptionCopy(value) {
      return String(value || '')
        .replace(/\s*\+\s*€\s*[\d.]+(?:,\d{1,2})?\s*(?:EUR)?\s*$/i, '')
        .replace(/\s*\+\s*[\d.]+(?:,\d{1,2})?\s*EUR\s*$/i, '')
        .trim();
    }

    function optionPriceCents(label, nativeValue) {
      var source = [label, nativeValue].filter(Boolean).join(' ');
      var key = mappedPriceKey(source);
      if (key && Object.prototype.hasOwnProperty.call(gpoLivePrices, key)) return gpoLivePrices[key];
      var match = source.match(/\+\s*€?\s*([\d.]+(?:,\d{1,2})?)\s*(?:EUR)?/i);
      return match ? parseMoneyCents(match[1]) : 0;
    }

    function renderSelectCardCopy(button) {
      if (!button) return;
      var copy = button.querySelector('.mg-gpo-select-card__copy');
      if (!copy) return;
      var label = button.dataset.label || '';
      var cents = optionPriceCents(label, button.dataset.value || '');
      var title = copy.querySelector('.mg-gpo-select-card__title');
      var price = copy.querySelector('.mg-gpo-select-card__price');
      if (title) title.textContent = cleanOptionCopy(label);
      if (price) price.textContent = cents > 0 ? ('+ ' + formatEuro(cents)) : 'GRATIS';
    }

    function mappedPriceKey(name) {
      var upper = String(name || '').toUpperCase();
      return Object.keys(gpoLivePrices).sort(function (a, b) { return b.length - a.length; }).find(function (candidate) {
        return upper.indexOf(candidate) > -1;
      }) || null;
    }

    function selectedPriceKeys() {
      var keys = [];
      if (!slot) return keys;
      slot.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (input) {
        var key = mappedPriceKey(textOf(optionLabel(input)));
        if (key && keys.indexOf(key) === -1) keys.push(key);
      });
      slot.querySelectorAll('select').forEach(function (select) {
        if (!select.value || select.selectedIndex < 0) return;
        var key = mappedPriceKey(textOf(select.options[select.selectedIndex]));
        if (key && keys.indexOf(key) === -1) keys.push(key);
      });
      return keys;
    }

    function hydrateSelectedLivePrices() {
      selectedPriceKeys().forEach(function (key) {
        var record = gpoOptionRecords[key];
        if (!record || !record.productHandle || !record.variantId) return;
        var requestKey = record.productHandle + '::' + record.variantId;
        if (!livePriceRequests[requestKey]) {
          livePriceRequests[requestKey] = window.fetch('/products/' + encodeURIComponent(record.productHandle) + '.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then(function (response) {
            if (!response.ok) throw new Error('Prezzo variante non disponibile');
            return response.json();
          }).then(function (product) {
            var variant = (product.variants || []).find(function (item) {
              return String(item.id) === String(record.variantId);
            });
            if (!variant || !Number.isFinite(Number(variant.price))) throw new Error('Variante prezzo non trovata');
            gpoLivePrices[key] = Number(variant.price);
            return gpoLivePrices[key];
          }).catch(function () {
            // Keep the deploy-verified profile price as a zero-jank fallback.
            return gpoLivePrices[key];
          });
        }
        livePriceRequests[requestKey].then(updatePrices);
      });
    }

    function selectedAddonCents() {
      var mappedTotal = 0;
      var mappedSelections = 0;
      if (slot && Object.keys(gpoLivePrices).length) {
        slot.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (input) {
          var label = optionLabel(input);
          var name = textOf(label).toUpperCase();
          var key = mappedPriceKey(name);
          if (key) {
            mappedTotal += gpoLivePrices[key];
            mappedSelections += 1;
          }
        });
        slot.querySelectorAll('select').forEach(function (select) {
          if (!select.value || select.selectedIndex < 0) return;
          var name = textOf(select.options[select.selectedIndex]).toUpperCase();
          var key = mappedPriceKey(name);
          if (key) {
            mappedTotal += gpoLivePrices[key];
            mappedSelections += 1;
          }
        });
        if (mappedSelections) return mappedTotal;
      }
      var totalNode = slot && slot.querySelector('.gpo-total-text .money, .gpo-total .money');
      if (totalNode && textOf(totalNode)) return parseMoneyCents(textOf(totalNode));

      var total = 0;
      if (!slot) return total;
      slot.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (input) {
        var option = input.closest('.dropdown-item, label, .gpo-swatches-container');
        var price = option && option.querySelector('.addOn, .addon, [class*="price"]');
        if (price) total += parseMoneyCents(textOf(price));
      });
      slot.querySelectorAll('select').forEach(function (select) {
        if (!select.value || select.selectedIndex < 0) return;
        total += parseMoneyCents(textOf(select.options[select.selectedIndex]));
      });
      return total;
    }

    function updatePrices() {
      var addonCents = selectedAddonCents();
      var total = basePriceCents + addonCents;
      // Add-ons are part of the configured machine, so move the reference
      // price by the same amount. This preserves the verified base saving and
      // can never leave a crossed-out price below the actual configured total.
      var configuredCompare = Math.max(total, baseComparePriceCents + addonCents);
      var configuredSaving = Math.max(0, configuredCompare - total);
      var totalText = formatEuro(total);
      var monthlyText = formatEuro(Math.round(total / 36));
      setText(configTotal, totalText);
      setText(productPrice, totalText);
      setText(comparePrice, formatEuro(configuredCompare));
      setText(savingLabel, 'RISPARMI ' + formatEuro(configuredSaving));
      if (comparePrice) comparePrice.hidden = configuredSaving <= 0;
      if (savingLabel) savingLabel.hidden = configuredSaving <= 0;
      setText(heroMonthly, monthlyText);
      setText(financeMonthly, monthlyText);
      if (configMonthly) configMonthly.innerHTML = monthlyText + '<em>/MESE</em>';
    }

    function readCartCount() {
      return window.fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }).then(function (cart) {
        return Number(cart.item_count || 0);
      });
    }

    function setAddingState(active) {
      root.querySelectorAll('.mg-rex-atc').forEach(function (button) {
        button.classList.toggle('is-adding', active);
        button.setAttribute('aria-busy', String(active));
      });
    }

    function updateCartBadge(count) {
      var badge = root.querySelector('.mg-rex-cart-link b');
      if (badge) setText(badge, String(count));
    }

    function openCartModal() {
      if (!cartModal) return;
      var nativeDrawer = document.getElementById('Cart-Drawer');
      if (nativeDrawer) {
        if (typeof nativeDrawer.hide === 'function') nativeDrawer.hide();
        else nativeDrawer.removeAttribute('open');
      }
      cartModal.hidden = false;
      document.documentElement.classList.add('mg-rex-modal-open');
      document.dispatchEvent(new CustomEvent('mg:crosssell-open'));
      var firstAction = cartModal.querySelector('.mg-rex-cart-modal__close, [data-mg-modal-continue]');
      if (firstAction) window.setTimeout(function () { firstAction.focus(); }, 20);
    }

    function closeCartModal() {
      if (!cartModal) return;
      cartModal.hidden = true;
      document.documentElement.classList.remove('mg-rex-modal-open');
    }

    function continueToNativeCart(opener) {
      closeCartModal();
      if (window.MGLiveCart && typeof window.MGLiveCart.open === 'function') {
        window.MGLiveCart.open(opener || document.activeElement);
      } else {
        window.location.assign('/cart');
      }
    }

    function showToast(message) {
      if (!toast) return;
      setText(toast, message || 'AGGIUNTO AL CARRELLO');
      toast.hidden = false;
      window.clearTimeout(showToast.timer);
      showToast.timer = window.setTimeout(function () { toast.hidden = true; }, 2600);
    }

    function watchCartAndOpen() {
      if (root.dataset.cartRedirectArmed === 'true') return;
      root.dataset.cartRedirectArmed = 'true';
      setAddingState(true);

      var started = Date.now();
      var baselinePromise = knownCartCount === null
        ? readCartCount().then(function (count) { knownCartCount = count; return count; })
        : Promise.resolve(knownCartCount);

      baselinePromise.then(function (baseline) {
        function check() {
          readCartCount().then(function (count) {
            if (count > baseline) {
              knownCartCount = count;
              updateCartBadge(count);
              root.dataset.cartRedirectArmed = 'false';
              setAddingState(false);
              openCartModal();
              return;
            }
            if (Date.now() - started < 8000) {
              cartRedirectTimer = window.setTimeout(check, 350);
              return;
            }
            root.dataset.cartRedirectArmed = 'false';
            setAddingState(false);
          }).catch(function () {
            if (Date.now() - started < 8000) {
              cartRedirectTimer = window.setTimeout(check, 500);
              return;
            }
            root.dataset.cartRedirectArmed = 'false';
            setAddingState(false);
          });
        }
        cartRedirectTimer = window.setTimeout(check, 250);
      }).catch(function () {
        root.dataset.cartRedirectArmed = 'false';
        setAddingState(false);
      });
    }

    function closeOtherGroups(current) {
      if (!slot) return;
      slot.querySelectorAll('.gpo-element.is-mg-open').forEach(function (group) {
        if (group !== current) {
          group.classList.remove('is-mg-open');
          var toggle = group.querySelector('.mg-gpo-summary');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function hydrateOptionImages(scope) {
      if (!scope) return;
      scope.querySelectorAll('img[data-src]').forEach(function (image) {
        var source = image.dataset.src;
        if (source && image.getAttribute('src') !== source) {
          image.dataset.preloaded = 'true';
          image.src = source;
        }
      });
    }

    function decorateNativeSelect(select, type) {
      if (!select || select.dataset.mgCardified === 'true') return;
      select.dataset.mgCardified = 'true';
      select.classList.add('mg-gpo-native-select--cardified');

      var cards = document.createElement('div');
      cards.className = 'mg-gpo-select-cards';
      cards.setAttribute('role', 'listbox');
      cards.setAttribute('aria-label', select.getAttribute('aria-label') || 'Scegli il componente');

      Array.prototype.slice.call(select.options).forEach(function (option) {
        if (!option.value || option.disabled) return;
        var label = textOf(option);
        var proxy = document.createElement('span');
        proxy.textContent = label;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mg-gpo-select-card';
        button.dataset.value = option.value;
        button.setAttribute('role', 'option');
        button.dataset.label = label;
        button.innerHTML = '<span class="mg-gpo-option-image"><img alt="" width="180" height="140" loading="lazy" decoding="async"></span><span class="mg-gpo-select-card__copy"><strong class="mg-gpo-select-card__title"></strong><span class="mg-gpo-select-card__price"></span></span><span class="mg-gpo-select-card__check">✓</span>';
        var image = button.querySelector('img');
        image.src = transparentPixel;
        image.dataset.src = optionImage(proxy, type);
        renderSelectCardCopy(button);
        button.addEventListener('click', function () {
          select.value = option.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
        cards.appendChild(button);
      });

      function syncCards() {
        cards.querySelectorAll('.mg-gpo-select-card').forEach(function (button) {
          var selected = button.dataset.value === select.value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-selected', String(selected));
        });
      }
      select.addEventListener('change', syncCards);
      syncCards();
      select.insertAdjacentElement('afterend', cards);
    }

    function decorateGpo(app) {
      app.classList.add('mg-rex-gpo');
      var groups = Array.prototype.slice.call(app.querySelectorAll('.gpo-element'));

      groups.forEach(function (group, index) {
        if (group.dataset.mgDecorated === 'true') return;

        var labelNode = group.querySelector('.gpo-label, .gpo-label-wrapper, legend');
        var rawLabel = textOf(labelNode) || ('OPZIONE ' + (index + 1));
        var type = groupTypeFromLabel(rawLabel);
        var required = !!group.querySelector('.gpo-label.required, .required.gpo-label, [data-required="true"]') || /\*/.test(rawLabel);

        group.dataset.mgDecorated = 'true';
        group.dataset.mgGroupIndex = String(index + 1);
        group.dataset.mgGroupType = type;
        group.dataset.mgRequired = String(required);

        group.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
          var label = optionLabel(input);
          if (!label || label.querySelector('.mg-gpo-option-image')) return;
          var source = optionImage(label, type);
          var picture = document.createElement('span');
          picture.className = 'mg-gpo-option-image';
          var image = document.createElement('img');
          image.src = transparentPixel;
          image.dataset.src = source;
          image.alt = '';
          image.width = 180;
          image.height = 140;
          image.loading = 'lazy';
          image.decoding = 'async';
          picture.appendChild(image);
          label.prepend(picture);
          input.dataset.mgOptionImage = source;
        });

        group.querySelectorAll('select').forEach(function (select) {
          decorateNativeSelect(select, type);
        });

        var realControl = document.createElement('div');
        realControl.className = 'mg-gpo-real-control';
        Array.prototype.slice.call(group.children).forEach(function (child) { realControl.appendChild(child); });

        var row = document.createElement('div');
        row.className = 'mg-gpo-summary';
        row.setAttribute('role', 'button');
        row.setAttribute('tabindex', '0');
        row.setAttribute('aria-expanded', 'false');
        row.innerHTML =
          '<span class="mg-gpo-summary__index">' + (index + 1) + '.</span>' +
          '<b class="mg-gpo-summary__label"></b>' +
          '<img class="mg-gpo-summary__thumb" src="' + assets[type] + '" alt="" width="96" height="72" loading="lazy" decoding="async">' +
          '<span class="mg-gpo-summary__copy"><b></b><small></small></span>' +
          '<span class="mg-gpo-summary__state"><b></b><small>Modifica ›</small></span>';

        row.querySelector('.mg-gpo-summary__label').textContent = displayGroupLabel(rawLabel, type);
        row.querySelector('.mg-gpo-summary__copy small').textContent = descriptions[type];
        group.appendChild(row);
        group.appendChild(realControl);

        function toggleRow() {
          var open = !group.classList.contains('is-mg-open');
          closeOtherGroups(group);
          group.classList.toggle('is-mg-open', open);
          row.setAttribute('aria-expanded', String(open));
          if (open) {
            hydrateOptionImages(realControl);
            var control = realControl.querySelector('.dropdown-button, select, input:not([type="hidden"])');
            if (control) window.setTimeout(function () { control.focus({ preventScroll: true }); }, 30);
          }
        }

        row.addEventListener('click', toggleRow);
        row.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleRow();
          }
          if (event.key === 'Escape') {
            group.classList.remove('is-mg-open');
            row.setAttribute('aria-expanded', 'false');
          }
        });

        realControl.addEventListener('click', function () {
          window.setTimeout(function () { hydrateOptionImages(realControl); }, 60);
        });

        realControl.addEventListener('change', function () {
          window.setTimeout(function () {
            group.classList.remove('is-mg-open');
            row.setAttribute('aria-expanded', 'false');
            updateState();
          }, 50);
        });
      });

      updateState();
    }

    function requiredGroups() {
      if (!slot) return [];
      return Array.prototype.slice.call(slot.querySelectorAll('.gpo-element')).filter(function (group) {
        return visible(group) && groupRequired(group);
      });
    }

    function missingGroups() {
      return requiredGroups().filter(function (group) { return !groupComplete(group); });
    }

    function updateGroupSummary(group) {
      var selected = groupSelectedText(group);
      var complete = groupComplete(group);
      var type = group.dataset.mgGroupType || 'storage';
      var copy = group.querySelector('.mg-gpo-summary__copy b');
      var state = group.querySelector('.mg-gpo-summary__state b');
      var thumb = group.querySelector('.mg-gpo-summary__thumb');
      if (thumb) thumb.src = selectedOptionImage(group, type);
      if (complete) {
        setText(copy, selected || 'SELEZIONATO');
        setText(state, 'SELEZIONATO');
      } else if (groupRequired(group)) {
        setText(copy, 'SCEGLI IL COMPONENTE');
        setText(state, 'OBBLIGATORIO');
      } else {
        setText(copy, 'NESSUNA AGGIUNTA');
        setText(state, 'OPZIONALE');
      }
      group.classList.toggle('is-recommended-preview', false);
    }

    function updateState() {
      if (!slot) return;
      var required = requiredGroups();
      var missing = missingGroups();
      var complete = required.length - missing.length;
      var percentage = required.length ? Math.round((complete / required.length) * 100) : 0;
      if (progress) progress.style.width = percentage + '%';

      if (countLabel) {
        setText(countLabel, required.length
          ? (missing.length ? 'Apri le schede: completa ancora ' + missing.length + ' ' + (missing.length === 1 ? 'scelta obbligatoria' : 'scelte obbligatorie') + '.' : 'Configurazione completa. Puoi aggiungere ' + currentProductName + ' al carrello.')
          : 'Le opzioni GPO stanno caricando…');
      }

      if (summary) {
        setText(summary, missing.length
          ? 'Mancano ' + missing.length + ' ' + (missing.length === 1 ? 'scelta obbligatoria' : 'scelte obbligatorie') + '.'
          : 'Configurazione pronta per il carrello.');
        summary.classList.toggle('is-complete', missing.length === 0 && required.length > 0);
      }

      slot.querySelectorAll('.gpo-element').forEach(function (group) {
        group.classList.toggle('is-missing', missing.indexOf(group) > -1);
        updateGroupSummary(group);
      });

      updatePrices();
      hydrateSelectedLivePrices();
    }

    function revealMissing() {
      var missing = missingGroups();
      if (!slot || !slot.querySelector('.gpo-element')) {
        var config = root.querySelector('#personalizza-rex');
        if (config) config.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
      }
      if (!missing.length) return false;
      var first = missing[0];
      closeOtherGroups(first);
      first.classList.add('is-mg-open', 'is-invalid-pulse');
      var row = first.querySelector('.mg-gpo-summary');
      if (row) row.setAttribute('aria-expanded', 'true');
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(function () { first.classList.remove('is-invalid-pulse'); }, 1200);
      updateState();
      return true;
    }

    function moveGpo() {
      if (!slot) return false;
      var candidates = document.querySelectorAll('.gpo-app, .globo-form-app, [data-gpo-app]');
      var app = null;
      for (var i = 0; i < candidates.length; i += 1) {
        if (candidates[i].querySelector('.gpo-element')) {
          app = candidates[i];
          break;
        }
      }
      if (!app) return false;
      if (!slot.contains(app)) slot.appendChild(app);
      decorateGpo(app);
      return true;
    }

    function refreshProfileImages() {
      if (!slot) return;
      slot.querySelectorAll('.gpo-element').forEach(function (group) {
        var type = group.dataset.mgGroupType || groupTypeFromLabel(textOf(group.querySelector('.label-content, .gpo-label, legend, label')));
        group.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (input) {
          var label = optionLabel(input);
          var source = optionImage(label, type);
          input.dataset.mgOptionImage = source;
          var image = label && label.querySelector('.mg-gpo-option-image img');
          if (image) {
            image.dataset.src = source;
            if (group.classList.contains('is-mg-open') || image.dataset.preloaded === 'true') image.src = source;
          }
        });
        group.querySelectorAll('.mg-gpo-select-card').forEach(function (button) {
          var copy = button.querySelector('.mg-gpo-select-card__copy');
          var image = button.querySelector('.mg-gpo-option-image img');
          if (!image || !copy) return;
          var proxy = document.createElement('span');
          proxy.textContent = button.dataset.label || textOf(copy);
          var source = optionImage(proxy, type);
          image.dataset.src = source;
          renderSelectCardCopy(button);
          if (group.classList.contains('is-mg-open') || image.dataset.preloaded === 'true') image.src = source;
        });
      });
      updateState();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mg-gpo-slot], [data-mg-add-proxy], [data-mg-primary-submit]')) return;
      if (!slot) return;
      slot.querySelectorAll('.gpo-element.is-mg-open').forEach(function (group) {
        group.classList.remove('is-mg-open');
        var row = group.querySelector('.mg-gpo-summary');
        if (row) row.setAttribute('aria-expanded', 'false');
      });
    });

    if (!moveGpo()) {
      var mountObserver = new MutationObserver(function () {
        if (moveGpo()) mountObserver.disconnect();
      });
      mountObserver.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () {
        if (countLabel && !slot.querySelector('.gpo-element')) setText(countLabel, 'Impossibile caricare le opzioni GPO. Ricarica la pagina.');
      }, 9000);
    }

    profilePromise.then(function (profile) {
      applyProductProfile(profile);
      refreshProfileImages();
      // Images remain lazy and are fetched only when their actual GPO group
      // opens. Preloading the entire hardware library caused large, invisible
      // downloads on the first product-page visit.
    });

    if (slot) {
      slot.addEventListener('click', function () { window.setTimeout(updateState, 80); });
      new MutationObserver(function () { window.requestAnimationFrame(updateState); }).observe(slot, { childList: true, subtree: true, attributes: true, characterData: true });
    }

    function interceptGpoCartAdd() {
      if (window.__mgGpoCartAddPatched) return;
      window.__mgGpoCartAddPatched = true;
      var nativeFetch = window.fetch.bind(window);
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : ((input && input.url) || '');
        var method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var rawBody = init && init.body;
        var body = typeof rawBody === 'string' ? rawBody : '';
        var hasGpoPayload = body.indexOf('_gpo_product_group') > -1;
        if (!hasGpoPayload && window.FormData && rawBody instanceof window.FormData) {
          hasGpoPayload = rawBody.has('_gpo_product_group');
        }
        if (!hasGpoPayload && window.URLSearchParams && rawBody instanceof window.URLSearchParams) {
          hasGpoPayload = rawBody.has('_gpo_product_group');
        }
        var isGpoAdd = method === 'POST'
          && /\/cart\/add(\.js)?$/.test(String(url).split('?')[0])
          && hasGpoPayload;
        if (!isGpoAdd) return nativeFetch(input, init);

        // Globo composed the payload: the option add-on variants that carry
        // the surcharges plus the main product with its order properties.
        // Run it here so the cart is correct, then show the cross-selling
        // dialog. Globo's promise stays pending, so it never redirects.
        var forwardedHeaders = { Accept: 'application/json' };
        if (typeof rawBody === 'string' && /^\s*[\[{]/.test(rawBody)) forwardedHeaders['Content-Type'] = 'application/json';
        nativeFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: forwardedHeaders,
          body: rawBody
        }).then(function (response) {
          if (!response.ok) throw new Error('Impossibile aggiungere al carrello');
          return response.json();
        }).then(function () {
          return readCartCount();
        }).then(function (count) {
          knownCartCount = count;
          updateCartBadge(count);
          root.dataset.cartRedirectArmed = 'false';
          setAddingState(false);
          openCartModal();
        }).catch(function () {
          root.dataset.cartRedirectArmed = 'false';
          setAddingState(false);
          showToast('RIPROVA TRA POCO');
        });
        return new Promise(function () {});
      };
    }

    interceptGpoCartAdd();

    function selectedPaidAddons() {
      return slot ? slot.querySelectorAll('input:checked[gpo-data-variant-id]').length : 0;
    }

    function addConfigurationWithoutSurcharges() {
      if (root.dataset.mgFreeAddPending === 'true') return;
      var variantId = String(root.dataset.currentVariantId || '');
      if (!variantId) {
        showToast('RIPROVA TRA POCO');
        return;
      }
      var properties = {};
      if (slot) {
        slot.querySelectorAll('input:checked, select').forEach(function (control) {
          var propertyName = control.dataset.fieldName || control.name || '';
          var propertyValue = String(control.value || '').trim();
          if (propertyName && propertyValue && propertyName.charAt(0) !== '_') properties[propertyName] = propertyValue;
        });
      }
      root.dataset.mgFreeAddPending = 'true';
      setAddingState(true);
      window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: properties }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Impossibile aggiungere al carrello');
        return readCartCount();
      }).then(function (count) {
        knownCartCount = count;
        updateCartBadge(count);
        openCartModal();
      }).catch(function () {
        showToast('RIPROVA TRA POCO');
      }).finally(function () {
        root.dataset.mgFreeAddPending = 'false';
        root.dataset.cartRedirectArmed = 'false';
        setAddingState(false);
      });
    }

    if (form) {
      form.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-mg-primary-submit]');
        if (!trigger) return;
        if (revealMissing()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        if (!selectedPaidAddons()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          addConfigurationWithoutSurcharges();
          return;
        }

        // Globo renders a visible clone of the theme add-to-cart button and
        // its own handler is the one that adds the option surcharges to the
        // cart as separate line items. Forwarding this click to the hidden
        // original would drop those surcharges, so the clone is left to do
        // its job; interceptGpoCartAdd() below re-issues Globo's payload and
        // keeps the cross-selling dialog instead of its redirect to /cart.

        watchCartAndOpen();
      }, true);

      form.addEventListener('submit', function (event) {
        if (revealMissing()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (!selectedPaidAddons()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          addConfigurationWithoutSurcharges();
          return;
        }
        watchCartAndOpen();
      }, true);
    }

    if (addProxy) {
      addProxy.addEventListener('click', function () {
        if (revealMissing()) return;
        var submit = form && (
          form.querySelector('[data-mg-primary-submit].gpo-clone-atc-button') ||
          form.querySelector('[data-mg-primary-submit]')
        );
        if (submit) submit.click();
        else if (root.dataset.mgConfigurator === 'true') addConfigurationWithoutSurcharges();
      });
    }

    readCartCount().then(function (count) { knownCartCount = count; }).catch(function () {});

    var assuranceItems = root.querySelectorAll('.mg-rex-assurance details');
    assuranceItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        assuranceItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    var reviewSet = root.querySelector('[data-mg-review-set]');
    var reviewTrack = root.querySelector('[data-mg-review-track]');
    if (reviewSet && reviewTrack && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reviewTrack.classList.add('is-js-flow');
      var reviewAnimation = null;
      var reviewVisible = false;
      var reviewPaused = false;
      function runReviewFlow() {
        if (!reviewVisible || reviewPaused || reviewAnimation || !reviewSet.firstElementChild) return;
        var first = reviewSet.firstElementChild;
        var gap = parseFloat(window.getComputedStyle(reviewSet).columnGap || '0') || 0;
        var distance = first.getBoundingClientRect().width + gap;
        reviewAnimation = reviewTrack.animate([
          { transform: 'translate3d(0,0,0)' },
          { transform: 'translate3d(-' + distance + 'px,0,0)' }
        ], { duration: 7800, easing: 'linear' });
        reviewAnimation.onfinish = function () {
          reviewAnimation = null;
          reviewSet.appendChild(first);
          reviewTrack.style.transform = 'translate3d(0,0,0)';
          runReviewFlow();
        };
        reviewAnimation.oncancel = function () { reviewAnimation = null; };
      }
      new IntersectionObserver(function (entries) {
        reviewVisible = entries.some(function (entry) { return entry.isIntersecting; });
        if (reviewVisible) runReviewFlow();
        else if (reviewAnimation) { reviewAnimation.cancel(); reviewAnimation = null; }
      }, { rootMargin: '250px 0px', threshold: 0 }).observe(reviewTrack);
      var reviewViewport = reviewTrack.closest('.mg-rex-reviews__viewport');
      if (reviewViewport) {
        reviewViewport.addEventListener('mouseenter', function () { reviewPaused = true; if (reviewAnimation) reviewAnimation.pause(); });
        reviewViewport.addEventListener('mouseleave', function () { reviewPaused = false; if (reviewAnimation) reviewAnimation.play(); else runReviewFlow(); });
        reviewViewport.addEventListener('focusin', function () { reviewPaused = true; if (reviewAnimation) reviewAnimation.pause(); });
        reviewViewport.addEventListener('focusout', function () { reviewPaused = false; if (reviewAnimation) reviewAnimation.play(); else runReviewFlow(); });
      }
    }

    var audioButtons = root.querySelectorAll('[data-mg-audio-toggle]');
    var audio = root.querySelector('[data-mg-audio-player]');
    if (audioButtons.length && audio) {
      audioButtons.forEach(function (audioButton) { audioButton.addEventListener('click', function () {
        if (audio.paused) audio.play(); else audio.pause();
        audioButtons.forEach(function (button) {
          button.classList.toggle('is-playing', !audio.paused);
          button.setAttribute('aria-label', audio.paused ? 'Riproduci presentazione audio di REX' : 'Metti in pausa la presentazione audio di REX');
        });
      }); });
      audio.addEventListener('ended', function () { audioButtons.forEach(function (button) { button.classList.remove('is-playing'); }); });
    }

    var promoCode = root.querySelector('[data-mg-copy-code]');
    if (promoCode) {
      promoCode.addEventListener('click', function () {
        var code = promoCode.dataset.code || 'SCHOOL26';
        var label = promoCode.querySelector('[data-mg-copy-label]');
        var write = navigator.clipboard && navigator.clipboard.writeText
          ? navigator.clipboard.writeText(code)
          : Promise.reject(new Error('Clipboard API unavailable'));
        write.catch(function () {
          var fallback = document.createElement('textarea');
          fallback.value = code;
          fallback.setAttribute('readonly', '');
          fallback.style.position = 'fixed';
          fallback.style.opacity = '0';
          document.body.appendChild(fallback);
          fallback.select();
          document.execCommand('copy');
          fallback.remove();
        }).finally(function () {
          promoCode.classList.add('is-copied');
          setText(label, 'CODICE COPIATO');
          showToast('CODICE SCHOOL26 COPIATO');
          window.setTimeout(function () {
            promoCode.classList.remove('is-copied');
            setText(label, 'TOCCA PER COPIARE');
          }, 4500);
        });
      });
    }

    if (cartModal) {
      cartModal.querySelectorAll('[data-mg-modal-close]').forEach(function (button) {
        button.addEventListener('click', closeCartModal);
      });
      cartModal.querySelectorAll('[data-mg-modal-continue]').forEach(function (button) {
        button.addEventListener('click', function () { continueToNativeCart(button); });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !cartModal.hidden && document.querySelector('[data-mg-product-preview]')?.hidden !== false) closeCartModal();
      });
    }

    root.querySelectorAll('[data-mg-quick-form]').forEach(function (quickForm) {
      quickForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = quickForm.querySelector('button[type="submit"]');
        var quickPayload = new FormData(quickForm);
        var quickCard = quickForm.closest('[data-mg-cross-product], [data-mg-modal-product]');
        var hydratedVariantId = quickCard && quickCard.dataset.mgRecommendationVariantId;
        if (hydratedVariantId) quickPayload.set('id', hydratedVariantId);
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: quickPayload
        }).then(function (response) {
          if (!response.ok) throw new Error('Impossibile aggiungere il prodotto');
          return readCartCount();
        }).then(function (count) {
          knownCartCount = count;
          updateCartBadge(count);
          if (quickForm.closest('[data-mg-cart-modal]')) {
            if (button) {
              button.textContent = 'AGGIUNTO ✓';
              button.classList.add('is-added');
            }
            showToast('EXTRA AGGIUNTO AL CARRELLO');
          } else if (window.MGLiveCart && typeof window.MGLiveCart.open === 'function') {
            window.MGLiveCart.open(button);
          } else {
            showToast('AGGIUNTO AL CARRELLO');
          }
        }).catch(function () {
          showToast('RIPROVA TRA POCO');
        }).finally(function () {
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        });
      });
    });

    var boosterLab = root.querySelector('[data-mg-booster-lab]');
    if (boosterLab) {
      function fpsValue(element) {
        return Math.max(0, parseInt(element && element.firstChild ? element.firstChild.nodeValue : '0', 10) || 0);
      }

      function animateFps(element, target, duration) {
        if (!element || !element.firstChild) return;
        var startValue = fpsValue(element);
        var startedAt = window.performance.now();
        element.classList.remove('is-counting');
        window.requestAnimationFrame(function () { element.classList.add('is-counting'); });
        function frame(now) {
          var progressValue = Math.min(1, (now - startedAt) / duration);
          var eased = 1 - Math.pow(1 - progressValue, 3);
          element.firstChild.nodeValue = String(Math.round(startValue + ((target - startValue) * eased)));
          if (progressValue < 1) window.requestAnimationFrame(frame);
          else window.setTimeout(function () { element.classList.remove('is-counting'); }, 80);
        }
        window.requestAnimationFrame(frame);
      }

      function updateBoosterResolution(button, animate) {
        var factor = button.dataset.resolution === '1080' ? 1.18 : (button.dataset.resolution === '4k' ? .68 : 1);
        boosterLab.querySelectorAll('[data-resolution]').forEach(function (item) { item.classList.toggle('is-active', item === button); });
        boosterLab.querySelectorAll('.mg-rex-booster-games article').forEach(function (row) {
          var standard = row.querySelector('[data-fps-standard]');
          var boost = row.querySelector('[data-fps-boost]');
          var gain = row.querySelector('i');
          var standardValue = Math.round(Number(standard.dataset.base || 0) * factor);
          var boostValue = Math.round(Number(boost.dataset.base || 0) * factor);
          row.dataset.standardTarget = String(standardValue);
          row.dataset.boostTarget = String(boostValue);
          if (animate) {
            animateFps(standard, standardValue, 760);
            animateFps(boost, boostValue, 980);
          } else {
            standard.firstChild.nodeValue = String(standardValue);
            boost.firstChild.nodeValue = String(boostValue);
          }
          setText(gain, '+' + (boostValue - standardValue) + ' FPS');
          row.classList.remove('is-pulsing');
          window.requestAnimationFrame(function () { row.classList.add('is-pulsing'); });
        });
      }

      boosterLab.querySelectorAll('[data-resolution]').forEach(function (button) {
        button.addEventListener('click', function () {
          updateBoosterResolution(button, true);
        });
      });

      root.addEventListener('mg:product-profile', function () {
        var targetResolution = root.dataset.mgDefaultResolution || '1440';
        var targetButton = boosterLab.querySelector('[data-resolution="' + CSS.escape(targetResolution) + '"]') || boosterLab.querySelector('[data-resolution="1440"]');
        if (targetButton) updateBoosterResolution(targetButton, false);
      });

      var liveObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        var activeResolution = boosterLab.querySelector('[data-resolution].is-active') || boosterLab.querySelector('[data-resolution]');
        boosterLab.querySelectorAll('.mg-rex-booster-games article').forEach(function (row) {
          var standard = row.querySelector('[data-fps-standard]');
          var boost = row.querySelector('[data-fps-boost]');
          if (standard && standard.firstChild) standard.firstChild.nodeValue = String(Math.round(Number(standard.dataset.base || 0) * .72));
          if (boost && boost.firstChild) boost.firstChild.nodeValue = String(Math.round(Number(boost.dataset.base || 0) * .63));
        });
        window.requestAnimationFrame(function () { updateBoosterResolution(activeResolution, true); });
        liveObserver.disconnect();
      }, { threshold: .24 });
      liveObserver.observe(boosterLab);

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var fpsTick = 0;
        window.setInterval(function () {
          if (!document.documentElement.contains(boosterLab)) return;
          var rect = boosterLab.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          fpsTick += 1;
          boosterLab.querySelectorAll('.mg-rex-booster-games article').forEach(function (row, index) {
            var standard = row.querySelector('[data-fps-standard]');
            var boost = row.querySelector('[data-fps-boost]');
            var gain = row.querySelector('i');
            var standardTarget = Number(row.dataset.standardTarget || standard.dataset.base || 0);
            var boostTarget = Number(row.dataset.boostTarget || boost.dataset.base || 0);
            var standardSwing = Math.max(1, Math.round(standardTarget * .012));
            var boostSwing = Math.max(2, Math.round(boostTarget * .016));
            var direction = ((fpsTick + index) % 4 < 2) ? 1 : -1;
            var liveStandard = standardTarget + (direction * standardSwing);
            var liveBoost = boostTarget + (direction * boostSwing);
            animateFps(standard, liveStandard, 620);
            animateFps(boost, liveBoost, 760);
            setText(gain, '+' + (liveBoost - liveStandard) + ' FPS');
          });
        }, 1500);
      }
    }

    var perfSections = root.querySelectorAll('main > section, .mg-rex-reviews');
    if (perfSections.length) {
      var perfObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.target.classList.toggle('is-perf-active', entry.isIntersecting); });
      }, { rootMargin: '180px 0px', threshold: 0 });
      perfSections.forEach(function (section) { perfObserver.observe(section); });
    }

    var crossViewport = root.querySelector('[data-mg-cross-viewport]');
    var crossTrack = crossViewport && crossViewport.querySelector('.mg-rex-crosssell__track');
    var crossIndex = 0;
    function moveCross(direction) {
      if (!crossTrack || !crossViewport) return;
      var cards = crossTrack.children.length;
      var visibleCards = window.matchMedia('(max-width: 900px)').matches ? 1 : 3;
      crossIndex = Math.max(0, Math.min(Math.max(0, cards - visibleCards), crossIndex + direction));
      var card = crossTrack.children[crossIndex];
      crossTrack.style.transform = 'translateX(-' + (card ? card.offsetLeft : 0) + 'px)';
    }
    var crossPrev = root.querySelector('[data-mg-cross-prev]');
    var crossNext = root.querySelector('[data-mg-cross-next]');
    if (crossPrev) crossPrev.addEventListener('click', function () { moveCross(-1); });
    if (crossNext) crossNext.addEventListener('click', function () { moveCross(1); });

    var menuToggle = root.querySelector('[data-mg-menu-toggle]');
    var menuPanel = root.querySelector('[data-mg-menu-panel]');
    if (menuToggle && menuPanel) {
      function setMenu(open) {
        menuPanel.hidden = !open;
        menuToggle.classList.toggle('is-open', open);
        menuToggle.setAttribute('aria-expanded', String(open));
        menuToggle.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Apri il menu');
      }

      menuToggle.addEventListener('click', function () {
        setMenu(menuPanel.hidden);
      });

      menuPanel.addEventListener('click', function (event) {
        if (event.target.closest('a')) setMenu(false);
      });

      document.addEventListener('click', function (event) {
        if (!menuPanel.hidden && !event.target.closest('.mg-rex-nav__inner')) setMenu(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !menuPanel.hidden) {
          setMenu(false);
          menuToggle.focus();
        }
      });
    }
  }

  document.querySelectorAll('[data-mg-rex-pdp]').forEach(setup);
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mg-rex-pdp]');
    if (root) setup(root);
  });
})();
